// extracted by mini-css-extract-plugin
export default {"overlay":"Lightbox_overlay__yuvGM","fadeIn":"Lightbox_fadeIn__1ujVM","image":"Lightbox_image__Ri90g","scaleIn":"Lightbox_scaleIn__EACSJ","close":"Lightbox_close__Jt7qF"};